import { useTranslation } from "react-i18next";

/** The charts' own UI strings (`charts.*`), in the interface language. */
export function useChartStrings() {
  const { t } = useTranslation();
  return {
    showTable: t("charts.showTable"),
    showChart: t("charts.showChart"),
    total: t("charts.total"),
    share: t("charts.share"),
  };
}
